var render = function () {
  var _vm$availabilityItem, _vm$availabilityItem2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "d-flex flex-column align-center mb-12 rounded-lg"
  }, [_c('h1', {
    staticClass: "text-h2 text-center primary--text font-weight-bold"
  }, [_vm._v(" Library of Things ")]), _c('v-dialog', {
    attrs: {
      "value": !!((_vm$availabilityItem = _vm.availabilityItem) !== null && _vm$availabilityItem !== void 0 && _vm$availabilityItem.id),
      "max-width": "500",
      "persistent": "",
      "transition": "dialog-transition"
    }
  }, [!!((_vm$availabilityItem2 = _vm.availabilityItem) !== null && _vm$availabilityItem2 !== void 0 && _vm$availabilityItem2.id) ? _c('ci-availability', {
    attrs: {
      "categoriesById": _vm.categoriesById,
      "item": _vm.availabilityItem
    },
    on: {
      "close": function ($event) {
        _vm.availabilityItem = null;
      }
    }
  }) : _vm._e()], 1), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "px-0 px-sm-3",
    attrs: {
      "cols": "12",
      "lg": "10",
      "xl": "8"
    }
  }, [_c('v-card', {
    staticClass: "mt-16"
  }, [_c('v-card-text', {
    staticClass: "d-flex flex-column align-start primary--text"
  }, [_c('p', {
    staticClass: "text-body-1 primary--text font-weight-black mb-1"
  }, [_vm._v(" The library has a collection of items that patrons may borrow for home use. ")]), _c('p', {
    staticClass: "primary--text text--lighten-2 font-weight-bold mb-0"
  }, [_vm._v(" To borrow, patrons must be at least 18 years old and have an Adult library card from the East Islip Public Library that is in good standing. ")]), _c('v-card', {
    staticClass: "primary--text mt-1",
    attrs: {
      "flat": "",
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pb-0"
  }, [_c('v-avatar', {
    staticClass: "mr-2",
    attrs: {
      "color": "#088f25",
      "size": "19"
    }
  }), _c('p', {
    staticClass: "text-body-1 font-weight-bold mb-0"
  }, [_vm._v("Lawn Games")])], 1), _c('v-card-text', {
    staticClass: "primary--text pt-0"
  }, [_c('ul', {
    staticClass: "text-body-2 font-weight-normal"
  }, [_c('li', [_vm._v("May be borrowed for up to 3 days with no renewals")]), _c('li', [_vm._v("Two games per household may be borrowed.")])])])], 1), _c('v-card', {
    staticClass: "primary--text mt-1",
    attrs: {
      "flat": "",
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pb-0"
  }, [_c('v-avatar', {
    staticClass: "mr-2",
    attrs: {
      "color": "#ff8508",
      "size": "19"
    }
  }), _c('p', {
    staticClass: "text-body-1 font-weight-bold mb-0"
  }, [_vm._v(" Library Equipment ")])], 1), _c('v-card-text', {
    staticClass: "primary--text pt-0"
  }, [_c('ul', {
    staticClass: "text-body-2 font-weight-normal"
  }, [_c('li', [_vm._v("May be borrowed for up to 14 days with no renewals.")]), _c('li', [_vm._v("Two items per household may be borrowed.")])])])], 1), _c('v-card', {
    staticClass: "primary--text mt-1",
    attrs: {
      "flat": "",
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "pb-0"
  }, [_c('v-avatar', {
    staticClass: "mr-2",
    attrs: {
      "color": "#f80a0a",
      "size": "19"
    }
  }), _c('p', {
    staticClass: "text-body-1 font-weight-bold mb-0"
  }, [_vm._v("WiFi Hotspots")])], 1), _c('v-card-text', {
    staticClass: "primary--text pt-0"
  }, [_c('ul', {
    staticClass: "text-body-2 font-weight-normal"
  }, [_c('li', [_vm._v(" May be borrowed for up to 14 days in one month per household with not more than two reservations in a one-month period. ")]), _c('li', [_vm._v(" No renewals are permitted. Only one hotspot per household may be borrowed at a time. ")])])])], 1)], 1), _c('v-card-actions', {
    staticClass: "d-flex flex-column align-start flex-wrap"
  }, [_c('p', {
    staticClass: "text-body-1 font-weight-bold primary--text mb-0"
  }, [_vm._v(" For reservations please call the library. ")]), _c('phone-button', {
    staticClass: "mt-4"
  })], 1)], 1)], 1), _c('v-col', {
    staticClass: "px-0 px-sm-3",
    attrs: {
      "cols": "12",
      "lg": "10",
      "xl": "8"
    }
  }, [_c('v-card', {
    staticClass: "d-flex flex-column justify-start",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-text', {
    staticClass: "pa-6"
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.categoriesAvailable,
      "item-text": "name",
      "item-value": "id",
      "label": "Category",
      "attach": "#mm",
      "multiple": "",
      "menu-props": {
        absolute: true,
        bottom: true,
        'min-width': '100%'
      },
      "chips": "",
      "full-width": "",
      "deletable-chips": "",
      "no-hint": "",
      "no-title": "",
      "clearable": "",
      "color": "primary"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('v-list-item-icon', [_c('v-icon', {
          domProps: {
            "textContent": _vm._s(_vm.filterCategory.includes(item.id) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline')
          }
        })], 1), _c('v-list-item-content', [_c('v-list-item-title', {
          domProps: {
            "textContent": _vm._s(item.name)
          }
        })], 1), _c('v-list-item-action', [_c('v-icon', {
          attrs: {
            "color": item.color
          },
          domProps: {
            "textContent": _vm._s('mdi-checkbox-blank-circle')
          }
        })], 1)];
      }
    }, {
      key: "selection",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('v-chip', {
          staticClass: "white--text font-weight-bold",
          attrs: {
            "color": item.color,
            "close": ""
          },
          on: {
            "click:close": function ($event) {
              _vm.filterCategory = _vm.filterCategory.filter(function (i) {
                return i !== item.id;
              });
            }
          }
        }, [_c('span', [_vm._v(_vm._s(item.name))])])];
      }
    }]),
    model: {
      value: _vm.filterCategory,
      callback: function ($$v) {
        _vm.filterCategory = $$v;
      },
      expression: "filterCategory"
    }
  }), _c('v-text-field', {
    staticClass: "flex-grow-0 flex-shrink-1",
    attrs: {
      "solo": "",
      "rounded": "",
      "clearable": "",
      "prepend-inner-icon": "mdi-magnify",
      "placeholder": "Search",
      "color": "primary"
    },
    model: {
      value: _vm.filterSearch,
      callback: function ($$v) {
        _vm.filterSearch = $$v;
      },
      expression: "filterSearch"
    }
  }), _c('v-sheet', {
    attrs: {
      "id": "mm",
      "height": "10",
      "width": "100%"
    }
  })], 1)], 1)], 1), _c('v-col', {
    staticClass: "text-center px-0 px-sm-3",
    attrs: {
      "cols": "12",
      "lg": "10",
      "xl": "8"
    }
  }, [_vm.isLoading ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _c('v-expansion-panels', {
    staticClass: "rounded-lg my-1",
    attrs: {
      "popout": ""
    }
  }, [_c('transition-group', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "name": "flip-list",
      "mode": "out-in"
    }
  }, _vm._l(_vm.itemList, function (item) {
    return _c('catalogItem', {
      key: item.id,
      staticClass: "mt-2 mt-sm-1",
      attrs: {
        "item": item,
        "categoriesById": _vm.categoriesById
      },
      on: {
        "checkAvailability": function ($event) {
          _vm.availabilityItem = item;
        }
      }
    });
  }), 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }